import * as React from "react";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";

export function UploadLoader({ open, cardData }) {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: 9999,
        backgroundColor: "rgba(10, 18, 35, 0.78)",
        backdropFilter: "blur(8px)",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <Box sx={{ position: "relative", display: "inline-flex", mb: 3 }}>
          <CircularProgress
            size={84}
            thickness={2.8}
            sx={{ color: cardData?.color || "#6366F1" }}
          />
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "2rem",
            }}
          >
            {cardData?.icon || "📄"}
          </Box>
        </Box>
        <Typography
          sx={{ color: "#ffffff", fontWeight: 700, fontSize: "1.2rem", letterSpacing: "-0.3px" }}
        >
          Uploading Bill...
        </Typography>
        <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: "0.875rem", mt: 0.5 }}>
          Please wait, do not close this window
        </Typography>
      </Box>
    </Backdrop>
  );
}

export function AutoFillLoader({ open, cardData }) {
  return (
    <Backdrop
      open={open}
      sx={{
        zIndex: 9998,
        backgroundColor: "rgba(10, 18, 35, 0.78)",
        backdropFilter: "blur(8px)",
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <Box sx={{ position: "relative", display: "inline-flex", mb: 3 }}>
          <CircularProgress
            size={84}
            thickness={2.8}
            sx={{ color: cardData?.color || "#FFB020" }}
          />
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "2rem",
            }}
          >
            {cardData?.icon || "⚡"}
          </Box>
        </Box>
        <Typography
          sx={{ color: "#ffffff", fontWeight: 700, fontSize: "1.2rem", letterSpacing: "-0.3px" }}
        >
          Fetching Bill Data...
        </Typography>
        <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: "0.875rem", mt: 0.5 }}>
          Connecting to {cardData?.company}
        </Typography>
        <Typography sx={{ color: "rgba(255,255,255,0.55)", fontSize: "0.875rem", mt: 0.5 }}>
          It takes some time
        </Typography>
      </Box>
    </Backdrop>
  );
}